import { Dispatch, GetState } from "common/types";

import { fetchMySchoolInfoAndPushValuesToDataLayer } from "seneca-common/features/schools/service/utils";
import { analyticsLogSignIn } from "seneca-common/utils/senecaAnalytics";

import { getRegion } from "features/regions/selectors";
import { setRegionPreference } from "features/user";
import { fetchAdditionalUserInfoOnSignIn } from "features/user/actions/auth/signInWithEmailAndPassword";
import { reconcileData } from "features/user/actions/auth/utils";
import { fetchUserInfo } from "features/user/actions/userInfo";
import { setUserAsSignedUpBefore } from "features/user/utils/signedUpBefore";

export default function completeLogin({
  regionBeforeAuthenticating
}: {
  regionBeforeAuthenticating?: string | null;
}) {
  return async function (dispatch: Dispatch, getState: GetState) {
    analyticsLogSignIn(getState());
    setUserAsSignedUpBefore();

    try {
      await Promise.all([
        fetchMySchoolInfoAndPushValuesToDataLayer(),
        dispatch(fetchUserInfo()),
        dispatch(reconcileData())
      ]);
    } catch (error) {}

    const region = getRegion(getState());
    if (!region && regionBeforeAuthenticating) {
      dispatch(setRegionPreference(regionBeforeAuthenticating));
    }

    await fetchAdditionalUserInfoOnSignIn(dispatch);
  };
}
